.orderLines {
  margin: var(--haus-cart__orderLines__margin, 0);
  padding: var(--haus-cart__orderLines__padding, 0);
  width: var(--haus-cart__orderLines__width, 100%);
}

.error {
  display: var(--haus-cart__error__display, flex);
  justify-content: var(--haus-cart__error__justify-content, center);
  align-items: var(--haus-cart__error__align-items, center);
  padding: var(--haus-cart__error__padding, 1rem);
}

.list {
  list-style: var(--haus-cart__list__list-style, none);
  margin: var(--haus-cart__list__margin, 0);
  padding: var(--haus-cart__list__padding, 0);
  display: var(--haus-cart__list__display, grid);
  gap: var(--haus-cart__list__gap, 16px);
}

.listItem {
  display: var(--haus-cart__item__display, flex);
  flex-direction: var(--haus-cart__item__flex-direction, row);
  justify-content: var(--haus-cart__item__justify-content, space-between);
  align-items: var(--haus-cart__item__align-items, stretch);

  gap: var(--haus-cart__item__gap, 16px);
  padding: var(--haus-cart__item__padding, 0 0 16px);
  border-bottom: var(--haus-cart__item__border-bottom, 1px solid rgba(0, 0, 0, 0.1));

  background: var(--haus-cart__item__background, #fff);
}

.listItem > * {
  width: var(--haus-cart__listItem__child__width, 100%);
}

.listItem:last-child {
  border-bottom: var(--haus-cart__listItem__border-bottom-last-child, none);
}

.itemWrapper {
  display: var(--haus-cart__itemWrapper__display, flex);
  flex-direction: var(--haus-cart__itemWrapper__flex-direction, row);
  gap: var(--haus-cart__itemWrapper__gap, 16px);
  justify-content: var(--haus-cart__itemWrapper__justify-content, flex-start);
  align-items: var(--haus-cart__itemWrapper__align-items, stretch);
  width: var(--haus-cart__itemWrapper__width, 100%);
  flex: var(--haus-cart__itemWrapper__flex, 1 1 auto);
  min-width: var(--haus-cart__itemWrapper__min-width, 0);
}

.imageWrapper {
  width: var(--haus-cart__imageWrapper__width, 100px);
  height: var(--haus-cart__imageWrapper__height, 100px);
  flex-shrink: var(--haus-cart__imageWrapper__flex-shrink, 0);
  display: var(--haus-cart__imageWrapper__display, flex);
  align-items: var(--haus-cart__imageWrapper__align-items, center);
  justify-content: var(--haus-cart__imageWrapper__justify-content, center);
  overflow: var(--haus-cart__imageWrapper__overflow, hidden);
  border-radius: var(--haus-cart__imageWrapper__border-radius, 6px);
  background: var(--haus-cart__imageWrapper__background, #f8fafc);

  img {
    display: var(--haus-cart__imageWrapper__img__display, block);
    width: var(--haus-cart__imageWrapper__img__width, 100%);
    height: var(--haus-cart__imageWrapper__img__height, 100%);
    margin: var(--haus-cart__imageWrapper__img__margin, auto);
    object-fit: var(--haus-cart__imageWrapper__img__object-fit, cover);
    object-position: var(--haus-cart__imageWrapper__img__object-position, center);
  }
}

.itemContent {
  display: var(--haus-cart__itemContent__display, flex);
  flex-direction: var(--haus-cart__itemContent__flex-direction, row);
  justify-content: var(--haus-cart__itemContent__justify-content, space-between);
  align-items: var(--haus-cart__itemContent__align-items, flex-start);
  align-content: var(--haus-cart__itemContent__align-content, space-between);
  gap: var(--haus-cart__itemContent__gap, 8px);
  flex-wrap: var(--haus-cart__itemContent__flex-wrap, wrap);
  width: var(--haus-cart__itemContent__width, 100%);
  height: var(--haus-cart__itemContent__height, 100%);
  padding: var(--haus-cart__itemContent__padding, 0);
}

.infoWrapper {
  display: var(--haus-cart__infoWrapper__display, flex);
  flex-direction: var(--haus-cart__infoWrapper__flex-direction, column);
  justify-content: var(--haus-cart__infoWrapper__justify-content, center);
  align-items: var(--haus-cart__infoWrapper__align-items, flex-start);
  align-self: var(--haus-cart__infoWrapper__align-self, flex-start);
  flex: var(--haus-cart__infoWrapper__flex, 0 1 auto);
  min-width: var(--haus-cart__infoWrapper__min-width, 0);
}

.quantity {
  display: var(--haus-cart__quantity__display, flex);
  align-items: var(--haus-cart__quantity__align-items, center);
  margin-top: var(--haus-cart__quantity__margin-top, 8px);
}

.quantityText {
  display: var(--haus-cart__quantityText__display, block);
  margin-top: var(--haus-cart__quantityText__margin-top, 8px);
  color: var(--haus-cart__quantityText__color, var(--haus-color-body, #323231));
}

.addToCartButtonWrapper {
  max-width: var(--haus-cart__addToCartButtonWrapper__max-width, 140px);
  --haus-addtocartbutton__additemtoorderroot__min-height: var(
    --haus-cart__addToCartButtonWrapper__additemtoorderroot__min-height,
    34px
  );
  --haus-addtocartbutton__additemtoorderroot__height: var(
    --haus-cart__addToCartButtonWrapper__additemtoorderroot__height,
    34px
  );
  --haus-addtocartbutton__button__min-height: var(
    --haus-cart__addToCartButtonWrapper__button__min-height,
    34px
  );
  --haus-addtocartbutton__button__height: var(
    --haus-cart__addToCartButtonWrapper__button__height,
    34px
  );
  --haus-addtocartbutton__quantitycontainer__min-height: var(
    --haus-cart__addToCartButtonWrapper__quantitycontainer__min-height,
    34px
  );
  --haus-addtocartbutton__quantitycontainer__height: var(
    --haus-cart__addToCartButtonWrapper__quantitycontainer__height,
    34px
  );
  --haus-addtocartbutton__quantityadjust__min-height: var(
    --haus-cart__addToCartButtonWrapper__quantityadjust__min-height,
    28px
  );
  --haus-addtocartbutton__quantityadjust__svg__width: var(
    --haus-cart__addToCartButtonWrapper__quantityadjust__svg__width,
    14px
  );
  --haus-addtocartbutton__quantityadjust__svg__height: var(
    --haus-cart__addToCartButtonWrapper__quantityadjust__svg__height,
    14px
  );
  --haus-addtocartbutton__quantityinput__font-size: var(
    --haus-cart__addToCartButtonWrapper__quantityinput__font-size,
    13px
  );
  --haus-button-padding: var(--haus-cart__addToCartButtonWrapper__button__padding, 0 12px);
  --haus-button-font-size: var(--haus-cart__addToCartButtonWrapper__button__font-size, 13px);
}

.orderLinePriceWrapper {
  color: var(--haus-cart__orderLinePriceWrapper__color, var(--haus-color-primary), #ec622b);
  font-family: var(
    --haus-cart__orderLinePriceWrapper__font-family,
    var(--haus-typography-body-font-family),
    'Inter, sans-serif'
  );
  font-size: var(
    --haus-cart__orderLinePriceWrapper__font-size,
    var(--haus-typography-body-font-size),
    16px
  );
  font-style: var(
    --haus-cart__orderLinePriceWrapper__font-style,
    var(--haus-typography-body-font-style),
    normal
  );
  font-weight: var(
    --haus-cart__orderLinePriceWrapper__font-weight,
    var(--haus-typography-body-font-weight),
    700
  );
  line-height: var(
    --haus-cart__orderLinePriceWrapper__line-height,
    var(--haus-typography-body-line-height),
    24px
  );
  display: var(--haus-cart__orderLinePriceWrapper__display, flex);
  align-items: var(--haus-cart__orderLinePriceWrapper__align-items, center);
  justify-content: var(--haus-cart__orderLinePriceWrapper__justify-content, flex-start);
  align-self: var(--haus-cart__orderLinePriceWrapper__align-self, flex-start);

  flex-shrink: var(--haus-cart__orderLinePriceWrapper__flex-shrink, 0);
  //margin-left: var(--haus-cart__orderLinePriceWrapper__margin-left, auto);
  text-align: var(--haus-cart__orderLinePriceWrapper__text-align, right);
}

.pricewrapper {
  display: var(--haus-cart__pricewrapper__display, flex);
  flex-direction: var(--haus-cart__pricewrapper__flex-direction, column);
  align-items: var(--haus-cart__pricewrapper__align-items, flex-end);
  justify-content: var(--haus-cart__pricewrapper__justify-content, flex-end);
  gap: var(--haus-cart__pricewrapper__gap, 0);
}

.priceLoading {
  filter: var(--haus-cart__priceLoading__filter, blur(2px));
  transition: var(--haus-cart__priceLoading__transition, filter 0.2s ease);
}

.productName {
  overflow: var(--haus-cart__productName__overflow, hidden);
  color: var(--haus-cart__productName__color, var(--haus-color-body), #323231);
  text-overflow: var(--haus-cart__productName__text-overflow, ellipsis);
  font-family: var(
    --haus-cart__productName__font-family,
    var(--haus-typography-body-font-family),
    'Inter, sans-serif'
  );
  font-size: var(--haus-cart__productName__font-size, var(--haus-typography-body-font-size), 16px);
  font-style: var(
    --haus-cart__productName__font-style,
    var(--haus-typography-body-font-style),
    normal
  );
  font-weight: var(
    --haus-cart__productName__font-weight,
    var(--haus-typography-body-font-weight),
    700
  );
  line-height: var(
    --haus-cart__productName__line-height,
    var(--haus-typography-body-line-height),
    24px
  );
  text-decoration: var(--haus-cart__productName__text-decoration, none);

  &:hover {
    text-decoration: var(--haus-cart__productName__text-decoration-hover, underline);
  }
}

.removeButton {
  display: var(--haus-cart__removeButton__display, flex);
  width: var(--haus-cart__removeButton__width, 40px);
  height: var(--haus-cart__removeButton__height, 40px);
  min-width: var(--haus-cart__removeButton__min-width, 40px);
  min-height: var(--haus-cart__removeButton__min-height, 40px);
  justify-content: var(--haus-cart__removeButton__justify-content, center);
  align-items: var(--haus-cart__removeButton__align-items, center);
  border-radius: var(--haus-cart__removeButton__border-radius, 50%);
  border: var(--haus-cart__removeButton__border, none);
  background-color: var(--haus-cart__removeButton__background-color, transparent);
  color: var(--haus-cart__removeButton__color, var(--haus-color-body, #323231));
  text-decoration: var(--haus-cart__removeButton__text-decoration, none);
  cursor: var(--haus-cart__removeButton__cursor, pointer);
  flex-shrink: var(--haus-cart__removeButton__flex-shrink, 0);

  svg {
    width: var(--haus-cart__removeButton__svg__width, 16px);
    height: var(--haus-cart__removeButton__svg__height, 16px);
    color: var(--haus-cart__removeButton__svg__color, var(--haus-color-body), #323231);
  }

  &:hover {
    background-color: var(--haus-cart__removeButton__background-color-hover, transparent);
  }
}
